import { MEDIAVINE_INCONTENT_CSS_CLASS } from '@/defs/ad'

export const AdIncontent = () => <div className={MEDIAVINE_INCONTENT_CSS_CLASS} data-slot='content' />
